export enum ImageTypes {
  'LOGO',
  'IMGLOGIN',
  'FAVICON',
  'TOPBANNER',
}
